import React from "react"
import { Grid } from "@mui/material"

import { AppCardTitle, AppCrudTable } from "@components"
import { userSettingWebSupplierGroupData } from "../@signals"
import { actionsColumn, nameColumn, webSuppliersColumn } from "./columns"
import WebSupplierGroupDrawer from "./Drawer"
import WebSupplierGroupTabButton from "./Button"


export default function UserSettingWebSupplierGroupTab() {
	return <Grid container spacing={1}>
		{!!userSettingWebSupplierGroupData.value?.length && <Grid item xs={12}>
			<AppCrudTable
				// The tab's create button with the table's own actions, as every list of the app
				options={{ customToolbar: () => <WebSupplierGroupTabButton/> }}
				title={<AppCardTitle icon="store" title="Your Web Supplier Groups"/>}
				data={userSettingWebSupplierGroupData.value}
				columns={[
					nameColumn(),
					webSuppliersColumn(),
					actionsColumn(),
				]}
			/>
		</Grid>}

		<WebSupplierGroupDrawer />
	</Grid>
}